function addWeekdays(date, days) {
  let count = 0;
  while (count < days) {
    date.setDate(date.getDate() + 1);
    if (date.getDay() !== 0 && date.getDay() !== 6) {
      // Increment count only on weekdays (Monday to Friday)
      count++;
    }
  }
  return date;
}

function formatDate(date) {
  const options = { weekday: 'long', day: 'numeric', month: 'long' };
  return date ? date.toLocaleDateString('en-US', options) : 'Invalid Date';
}

// Create a new Date object for the current date
let currentDate = new Date();

// Determine the number of weekdays to add (e.g., 5 for a week)
const weekdaysToAdd = 5;

// Add weekdays to the current date
let futureDate = addWeekdays(new Date(currentDate), weekdaysToAdd);

// Format the future date as a string
let formattedFutureDate = formatDate(futureDate);

// Display the result on the webpage
let displayElement = document.getElementById('futureDateDisplay');
if (displayElement) {
  displayElement.textContent = `${formattedFutureDate}`;
} else {
  console.error('Element with id "futureDateDisplay" not found.');
}